import { render } from "./role-type-form.vue?vue&type=template&id=f53ce5ee"
import script from "./role-type-form.vue?vue&type=script&lang=js"
export * from "./role-type-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__